import Vue from 'vue'
import VueRouter from 'vue-router'
import pageMap from '~config/pageMap'
import store from '../vuex'
import Constants from '../Constants';
import getHomePageId from '~common/js/page-util.js';

class Router {
  constructor (mode, i18n) {
    this.mode = mode;
    this.i18n = i18n;
    this.router = null;
    Vue.use(VueRouter);
  }

  getInstance() {
    if (!this.router) {
      this.router = new VueRouter({
        mode: this.mode,
        routes: pageMap,
      });
    }
    return this.router;
  }

  setPageLoader(pageLoader) {
    this.pageLoader = pageLoader;
  }

  checkAuth() {
    return store.state.isLoggedIn;
  }

  installAPI() {
    window.utils.install('goPage', this.goPage.bind(this));
    window.utils.install('goHome', this.goHome.bind(this));
    window.utils.install('goEmpty', this.goEmpty.bind(this));
  }

  init() {
    const router = this.getInstance();
    this.installAPI();

    router.beforeEach((to, from, next) => {
      let pageId = null;
      let sourcePageId = null;
      if (to.matched && to.matched.length) {
        const target = to.matched[0];
        if (target.props.default && target.props.default._routerlinkPageId) { // link인경우 prop에 임으로 넣어서 사용함
          pageId = target.path.split('/')[1];
          if (!pageId) { // 홈카드 처리
            pageId = target.props.default._routerlinkPageId;
          }
        } else if (target.name) { // link인 경우 name이 없음
          pageId = target.name;
        } else if (target.components) {
          pageId = target.components.default.name;
        }
      } else {
        pageId = to.name;
      }
      if (!pageId || pageId.indexOf('PGE_') === -1 // redirect인경우 skip
        || !this.checkAuth()) { // 로그인하지 않은 경우, pageId로 화면 접근하지 않기 때문에 pageId에 대한 권한 확인 불필요
        pageId = null;
      }

      if (this.isPageAccessible(pageId) === false) { // 테넌트 또는 사용자의 상태가 해당 pageId에 접근할 수 없는 경우
        pageId = null;
      }

      if (pageId) {
        http.loadPageMeta(pageId, true).then(
          meta => {
            if (this.isPageBlocked(meta)) {
              window.$toast.makeToast(`${this.getPageBlockMessage(pageMeta)}`);
            } else {
              // if (sourcePageId) { // link인경우, source가 되는 page 메타도 로드함
              //   http.loadPageMeta(sourcePageId, true).then(() => {
              //     next();
              //     utils.showNotices(meta.noticeList);
              //   }).catch(()=>{
              //     next();
              //   });
              // } else {
              //   next();
              //   utils.showNotices(meta.noticeList);
              // }
              next();
              utils.showNotices(meta.noticeList);
            }
          }
        ).catch(
          error => {
            console.log(error);
            utils.wrongPageMessageBox();
          }
        )
      } else {
        if(to.path === '/Redirect' && to.query.pageId) {
          next(); // check validate
        } else if (to.path === '/') { // default 화면에서 새로고침 가능하도록 예외 처리
          next();
        } else if (to.path === '/Login' || to.path === '/FindPassword' || to.path === '/ConfirmPolicy' || to.path === '/InviteAdmission' || to.path === '/Welcome') { // 로그인, 비밀번호 찾기, 사용자 초대시 약관동의, 회원 가입, URL에 테넌트 접속경로가 없을 때 redirect 되는 안내 화면 예외 처리
          if (this.checkAuth()) { // 로그인 상태이면 초기 화면으로 이동
            next({path: '/'});
          } else {
            next();
          }
        } else if (to.path === '/ResetPassword') { // 비밀번호 재설정 화면 예외 처리
          if (this.checkAuth() || !store.state.loginId) { // 로그인 상태이거나 새로고침 또는 비정상적인 방법으로 비밀번호 재설정 화면으로 접속할 경우 초기 화면으로 이동
            next({path: '/'});
          } else {
            next();
          }
        } else if (to.path === '/ChangePassword') { // 만료 비밀번호 변경 화면 예외 처리
          if (this.checkAuth() || !store.state.passwordExpired) { // 로그인 상태이거나 새로고침 또는 비정상적인 방법으로 만료 비밀번호 변경 화면으로 접속할 경우 초기 화면으로 이동
            next({path: '/'});
          } else {
            next();
          }
        } else {
          console.log('wrong pageId');
          if (this.checkAuth()) { // 로그인 상태일 때만 홈화면 링크 팝업
            utils.wrongPageMessageBox();

          } else { // 로그인 상태가 아니면 초기 화면으로 바로 이동
            next({path: '/'});
          }
        }
      }
    });    
  }

  isValidRoutePath(pageId) {
    if (pageId && pageId.startsWith('PGE_')) {
      return true;
    }
    return false;
  }

  setMdiData(pageID) {
    if (store.state.mdiPages.indexOf(pageID) < 0) {
      store.commit('addPage', pageID);
    }
    if (store.state.activePage !== pageID) {
      store.commit('setActivePage', pageID);
    }
  }

  getPageState(pageMeta) {
    let state = Constants.STATE_PAGE_NORMAL;
    if (pageMeta && pageMeta[Constants.KEY_PAGE_INFO]) {
      state = pageMeta[Constants.KEY_PAGE_INFO][Constants.KEY_PAGE_INFO_STATE];
    }
    return state;
  }

  isPageBlocked(pageMeta) {
    if (pageMeta && (this.getPageState(pageMeta) === Constants.STATE_PAGE_BLOCK)) {
      return true;
    }
    return false;
  }

  isPageAccessible(pageId) {
    //약관동의 페이지
    if (pageId === 'PGE_AIM_00005' && store.getters.policyAgreeYn !== 'N') {
      return false;
    }

    //domain입력 화면
    if (pageId === 'PGE_AIM_00002' && store.getters.tenantStatus !== 'C') {
      return false;
    }

    //070 번호 입력화면
    if (pageId === 'PGE_AIM_00003' && store.getters.tenantStatus !== 'D') {
      return false;
    }

    return true;
  }

  getPageBlockMessage(pageMeta) {
    return pageMeta[Constants.KEY_PAGE_INFO][Constants.KEY_PAGE_INFO_BLOCK_MESSAGE];
  }
  
  goPage(pageId, params) {
	  this.getInstance().push({
		 path: pageId,
		 query: params
	  });
  }

  goHome() {
    let homepageId = getHomePageId(this.checkAuth());
    if (!homepageId) {
      homepageId = '/'; // 설정된 홈 화면이 없으면 초기 화면으로 이동
    }
    //store.commit('hideLNB');
    this.getInstance().push({
      path: homepageId,
     });
  }

  goEmpty() {
    this.getInstance().push({
      path: '/Empty',
     });
  }

}

export default Router;
